import useTranslation from '../hooks/useTranslation'
import { Disclosure } from './Disclosure'
import classNames from 'classnames'
import { useState } from 'react'

export const FrequentlyAskedQues = ({
  containerClassName = 'bg-[#F8F8F8]',
  TitleClassName = 'text-center',
  data = []
}) => {
  const translation = useTranslation()
  const [isSelected, setSelected] = useState()

  return (
    <div className={containerClassName}>
      <h6
        className={classNames(
          'text-left font-noto-sans text-[32px] font-[600] leading-[31px] text-greyTitleBase900'
        )}
        id="faq_header"
      >
        {translation?.faqFields.header}
      </h6>
      {data.map((item, index) => (
        <div key={index}>
          <Disclosure
            title={item?.header}
            isSelected={isSelected == index}
            containerClassName={classNames(
              'font-noto-sans text-[14px] leading-[19.07px] py-[16px]',
              index != data?.length - 1 && 'border-b-[1px]'
            )}
            titleClassNmae="font-noto-sans text-[14px] text-[#191919] leading-[19.07px] md:text-md md:leading-[21.79px]"
            childrenClassName="mt-[4px]"
            widthOfDownArrow={22}
            heightOfDownArrow={22}
            id={index}
            onClick={() => setSelected(index)}
          >
            {item.content.map((text, index) => (
              <div
                className="font-noto-sans text-[14px] leading-[19.07px] text-[#666]"
                key={index}
                id={`content-${index}`}
              >
                {text}
              </div>
            ))}
          </Disclosure>
        </div>
      ))}
    </div>
  )
}
